(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/matchen/assets/javascripts/views/coupon/outcome.js') >= 0) return;  svs.modules.push('/modules/matchen/assets/javascripts/views/coupon/outcome.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.matchen = svs.matchen || {};
  svs.matchen.views = svs.matchen.views || {};

  svs.matchen.views.Outcome = Marionette.View.extend({
    modelEvents: {
      change: 'render'
    },

    tagName: 'button',

    className: 'view-outcome outcome btn-bet btn-bet-default btn-bet-300',

    template: function(data) {
      return svs.matchen.templates.outcome(data);
    },

    triggers: {
      click: 'click'
    },

    onClick: function() {
      if (!this.isUnselectedAndDisabled()) {
        this.$el.toggleClass('btn-bet-selected', !this.model.get('selected'));
      }

      _.defer(function() {
        if (!this.isUnselectedAndDisabled()) {
          this.model.set('selected', !this.model.get('selected'));
        }
      }.bind(this));
    },

    onRender: function() {
      if (this.isUnselectedAndDisabled()) {
        this.$el.attr('disabled', true);
      } else {
        this.$el.removeAttr('disabled');
      }

      this.$el.toggleClass('btn-bet-selected', this.model.get('selected'));
      this.$el.toggleClass('hidden', this.model.get('hidden'));

      this.$el.attr('id', this.model.get('team') + this.model.get('outcome'));
    },

    isUnselectedAndDisabled: function() {
      return (
        this.model.get('unselectedDisabled') && !this.model.get('selected')
      );
    }
  });
})(Backbone, _, svs);


 })(window);